<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("rateCardgroup", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("rateCardgroup", 2) }}
        </div>
      </div>
      <div>
        <router-link
          v-if="$can('create', 'Rate Card Group')"
          variant="default"
          class="btn-blue"
          to="add-rate-card-group"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          @input="searchRateCardGroupList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <!-- <b-dropdown
            :text="filter_is_active_label"
            variant="dropdown-curve"
            class="ml-auto mr-3 movie-dropdown"
          >
            <b-dropdown-item @click="onChangeFilterIsActive('Active')"
            >Active</b-dropdown-item
            >
            <b-dropdown-item @click="onChangeFilterIsActive('Inactive')"
            >Inactive</b-dropdown-item
            >
            <b-dropdown-item @click="onChangeFilterIsActive('All')">All</b-dropdown-item>
          </b-dropdown> -->
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                this.getRateCardGroupList(filterIsActive);
              }
            "
          />
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status") }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'rc_g_name'"
              @click="onSortValue('rc_g_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('rc_g_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('rc_g_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("rateCardgroup") }}
          </th>
        </tr>
      </thead>
      <tbody v-if="RateCardGroup.length > 0">
        <tr v-for="(item, key) in RateCardGroup" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.rc_g_is_active ? 'active' : 'inactive'"
              />

              <!-- Icon with tooltip -->
              <span
                v-if="$can('update', 'Rate Card Group')"
                class="edit-pen ml-4 cursor-pointer blue-icon"
                v-b-tooltip="'Edit'"
                tabindex="0"
                @click="goToRoute('/cinema-manager/edit-rate-card-group', item)"
              ></span>
            </div>
          </td>

          <td>{{ $tc(item.rc_g_name, 1) }}</td>
          <!-- <td>
            <div class="d-flex align-items-center justify-content-end">
              <StatusDot
                :status="item.rc_g_is_active ? 'active' : 'inactive'"
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="
                    goToRoute('/cinema-manager/edit-rate-card-group', item)
                  "
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="text-center">
          <td colspan="2">
            <!-- <h6 class="ml-3">
              No Records Found
            </h6> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      RateCardGroup: [],
      customErrors: {
        message: "",
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",

      debounce: null,
      searchValue: "",
      // filter_is_active_label: 'Active',
      // filter_is_active: "Y"
    };
  },
  beforeMount() {
    this.getRateCardGroupList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    // onChangeFilterIsActive(option) {
    //   this.filter_is_active_label = option;
    //   switch (option.toLowerCase()) {
    //     case 'active':
    //       this.filter_is_active = 'Y';
    //       break;
    //     case 'inactive':
    //       this.filter_is_active = 'N';
    //       break;
    //     default:
    //       this.filter_is_active = null;
    //       break;
    //   }
    //   this.getRateCardGroupList();
    // },
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getRateCardGroupList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getRateCardGroupList();
      } else {
        this.currentPage = event;
        this.getRateCardGroupList();
      }
    },
    /* eslint-disable */
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { rc_g_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: rc_g_id,
        },
      });
    },
    searchRateCardGroupList: function (search) {
      this.getRateCardGroupList(undefined, 1, search);
    },
    getRateCardGroupList: function (
      filterIsActive = "Y",
      page = undefined,
      search = undefined
    ) {
      let payload = {
        limit: this.perPage,
        currentPage: page ? page : this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        searchValue: this.searchValue,
        filter_is_active: filterIsActive,
        is_private_rate_card: "N",
      };
      this.RateCardGroup = [];
      CinemasService.GetRateCardGroup(payload)
        .then((response) => {
          const { data } = response;
          this.rows = data.totalRows || 0;
          if (data.status) {
            if (data.Records.length > 0) {
              this.RateCardGroup = data.Records;
              this.RateCardGroup.map((x) => {
                x["rc_g_is_active"] = x.rc_g_is_active == "Y" ? true : false;
              });
              if (data.totalRows < 10) {
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RateCardGroupComponent/listRateCardGroup.vue